import {createContext} from 'react'

export const UnpaidWorkContext = createContext({
  modalOpen: false,
  setModalOpen: () => {
  },
  unpaidWorks: [],
  setUnpaidWorks: () => {
  },
  unpaidWork: {
    id: null,
    product_id: null,
    product_type: "",
    site_share: null,
    vat_share: null,
    agent_share: null,
    price: null,
    person_name: "",
    person_phone: "",
    agent_name: "",
    agent_phone: "",


  },
  setUnpaidWork: () => {
  },
  lastDataRefresh: Date.now(),
  setLastDataRefresh: () => {
  },
  roleId: null,
  setRoleId: () => {
  },
})